<template>
  <div class="table__overflow">
    <table class="table">

      <colgroup>
        <col
          v-for="(header, index) in flatHeaders"
          :key="'col_' + index"
          :style="{ width: header.width }"
        />
      </colgroup>

      <thead class="table__thead table__thead--sticky">
        <tr
          class="table__tr"
          v-for="(row, rowIndex) in headerRows"
          :key="'row_' + rowIndex"
        >
          <th
            class="table__th"
            v-for="(header, headerIndex) in row"
            :key="'header_' + rowIndex + '_' + headerIndex"
            :rowspan="getRowSpan(header)"
            :colspan="getColSpan(header)"
          >
            <span
              :class="{ 'hint hint--top hint--underline hint--md': header.hint }"
              :data-hint="header.hint"
            >
              {{ header.title }}
            </span>
          </th>
        </tr>
      </thead>

      <tbody>
        <slot />
      </tbody>

    </table>
  </div>
</template>

<script>
  export default {
    props: {
      tableHeaders: {
        type: Array,
        default: () => ([])
      },
      flatHeaders: {
        type: Array,
        default: () => ([])
      }
    },
    computed: {
      maxDepthTable() {
        const getMaxDepth = (header) => {
          if (!header.items || !header.items.length) return 1

          return 1 + Math.max(...header.items.map(getMaxDepth))
        }

        return Math.max(...this.tableHeaders.map(getMaxDepth))
      },
      headerRows() {
        const rows = []
        const processHeaders = (headers, depth = 0) => {
          if (!rows[depth]) rows[depth] = []
          headers.forEach(header => {
            rows[depth].push(header)
            if (header.items && header.items.length) {
              processHeaders(header.items, depth + 1)
            }
          })
        }

        processHeaders(this.tableHeaders)
        return rows;
      },
    },
    methods: {
      getRowSpan(header) {
        if (!header.items || header.items.length === 0) return this.maxDepthTable
        return 1
      },
      getColSpan(header) {
        if (!header.items || header.items.length === 0) return 1
        return header.items.reduce((acc, item) => acc + this.getColSpan(item), 0)
      }
    }
  }
</script>